import React from "react";
import { Container, Row, Col, Card, CardBody, Table, Button } from "reactstrap";

const Leaves = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3 align-items-center">
          <Col>
            <h4 className="card-title">Leave Applications & Management</h4>
            <p className="card-title-desc mb-0">Apply for leaves and manage team leave requests.</p>
          </Col>
          <Col className="text-end">
            <Button color="success" className="btn-rounded">
              <i className="mdi mdi-plus me-1"></i> Apply for Leave
            </Button>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table-centered table-nowrap mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Employee</th>
                        <th>Leave Type</th>
                        <th>From Date</th>
                        <th>To Date</th>
                        <th>Reason</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan="6" className="text-center py-4 text-muted">
                          No leave applications found.
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Leaves;
